import React from 'react';
import Button from './Button';
import { cardCls } from './styles';

interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  message?: string;
  action?: EmptyStateAction;
  /** Extra content rendered below the message (e.g. a tip or secondary hint). */
  children?: React.ReactNode;
  /** Tailwind classes for the icon container background. Default: bg-gray-100. */
  iconClassName?: string;
  /** Wraps the empty state in a card. Use for page-level empty states; omit for table/list inline empty states. */
  card?: boolean;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  message,
  action,
  children,
  iconClassName = 'bg-gray-100',
  card = false,
  className = '',
}) => {
  const content = (
    <div className="text-center">
      <div className="flex justify-center mb-3">
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center ${iconClassName}`}
          aria-hidden="true"
        >
          {icon}
        </div>
      </div>
      <h3 className="text-base font-medium text-gray-900 mb-1">{title}</h3>
      {message && <p className="text-sm text-gray-500 max-w-sm mx-auto">{message}</p>}
      {children && <div className="mt-5">{children}</div>}
      {action && (
        <Button variant="secondary" className="mt-4" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );

  if (card) {
    return <div className={`${cardCls} p-8 ${className}`}>{content}</div>;
  }

  return <div className={`py-12 ${className}`}>{content}</div>;
};

export default EmptyState;
